import CustomerStatusLabel from './CustomerStatusLabel';

export default CustomerStatusLabel;
